import { getPagePath, trans } from '@spotahome/soyuz/client';

import { Button } from '@spotahome/ui-library';
import KeyWithKeyRingReverse from '@spotahome/ui-library/src/tenant/components/icons/KeyWithKeyRingReverse';

import Section from '../Section';

import './HiwSocial.scss';

const HiwSocial = () => {
  return (
    <Section className="hiw-social">
      <div className="hiw-social__content">
        <KeyWithKeyRingReverse />
        <h2 className="hiw-social__title">
          {trans('how_it_works.social.title')}
        </h2>
        <Button color="primary" size="large" alt href={getPagePath('landing')}>
          {trans('how_it_works.social.cta')}
        </Button>
      </div>
    </Section>
  );
};

export default HiwSocial;
